import React from 'react';

import SvgMoneyIn from 'static/images/money-in.svg';
import SvgMoneyOut from 'static/images/money-out.svg';
import SvgIconRevert from 'static/images/icon-revert.svg';

const OperationIcon = ({
  amount,
  isRevert,
}: {
  amount: number;
  isRevert: boolean;
}) => {
  if (isRevert) return <img src={SvgIconRevert} alt="Icon revert" />;
  return amount > 0 ? (
    <img src={SvgMoneyIn} alt="Pay in" />
  ) : (
    <img src={SvgMoneyOut} alt="Pay out" />
  );
};

export default OperationIcon;
